const HTTPError = require('./HTTPError');

module.exports = HTTPError;
